import { Button, Grid } from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  FormatListBulletedSharp as FormatListBulletedSharpIcon,
} from "@mui/icons-material";
type Props = {
  setId: (id: number) => void;
  id: number;
  setShowEditModal: (show: boolean) => void;
  setShowDeleteModal: (show: boolean) => void;
  showContextMenu: () => void;
};
export const GridButtons = ({
  setId,
  id,
  setShowEditModal,
  setShowDeleteModal,
  showContextMenu,
}: Props) => {
  return (
    <Grid
      container
      style={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="ag-grid-buttons"
    >
      <Grid
        item
        xs={12}
        md={12}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          onClick={() => {
            (async () => {
              setId(id);
              setShowEditModal(true);
            })();
          }}
          title="Edit"
        >
          <EditIcon style={{ height: "auto" }} color="primary" />
        </Button>
        <Button
          onClick={() => {
            (async () => {
              setId(id);
              setShowDeleteModal(true);
            })();
          }}
          title="Delete"
        >
          <DeleteIcon style={{ height: "auto" }} color="secondary" />
        </Button>
        <Button style={{}} onClick={showContextMenu} title="Options">
          <FormatListBulletedSharpIcon
            style={{ height: "auto" }}
            color="action"
          />
        </Button>
      </Grid>
    </Grid>
  );
};
